export default function Symptoms() {
  const items = [
    'サイトにアクセスはあるが問い合わせがない',
    '広告を出しても成果が出ない／何を直すべきかわからない',
    '強みが文章では説明できるが、サイトで伝わっていない',
    '問い合わせフォームまで到達しても送信されない',
    'LPが「説明」になっていて「自分ごと」に刺さらない'
  ];

  return (
    <section id="symptoms" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-[1000px] mx-auto px-6 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-4">
            こんな状態なら、<br className="md:hidden" />まず"構造"から直すべきです
          </h2>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg">
          <ul className="space-y-5">
            {items.map((item, index) => (
              <li key={index} className="flex items-start gap-4">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-checkbox-circle-fill text-gray-900 text-2xl"></i>
                </div>
                <span className="text-base md:text-lg text-gray-700 leading-relaxed">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
